import { Component } from '@angular/core';

/**
 * @title Basic use of `<table mat-table>`
 */

@Component({
  selector: 'app-configuration-management-manage',
  templateUrl: './configuration.management.manage.component.html'
})
export class ConfigurationManagementManageComponent {
  
}